export const firstBotCreateActionType = "SAVE_FIRST_BOT_CREATE_PAGE";
